<div id="breadcrumb-navigation" class="breadcrumb">
  {{ labels.administration }}
  <a
    id="contratos-breadcrumb-link"
    class="breadcrumb-link selected"
    [routerLink]="['/wapi/admin/contratos']"
  >
    &nbsp;>&nbsp;{{ labels.contratos }}
  </a>
</div>

<br /><br />

<div id="contratos-main-container" class="container">
  <mat-card id="contratos-card">
    <div id="contratos-header" class="header-options">
      <div id="contratos-title" class="title">
        <div class="title-wrapper">
          <h1 class="main-title">{{ labels.contratos }}</h1>
        </div>
      </div>
      <div class="header-actions">
        <button
          mat-raised-button
          class="filter-button"
          (click)="toggleSearch()"
          matTooltip="Filtro"
        >
          <mat-icon>filter_list</mat-icon>
          FILTRO
        </button>
        <button
          mat-raised-button
          color="primary"
          class="create-button"
          (click)="openCreateModal()"
          matTooltip="{{ labels.createContrato }}"
        >
          <mat-icon>add</mat-icon>
          {{ labels.createContrato }}
        </button>
      </div>
    </div>

    <!-- Search Panel -->
    @if (showSearchPanel) {
      <div class="search-panel">
        <div class="filters-grid">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar contratos</mat-label>
            <input
              matInput
              [(ngModel)]="searchQuery"
              (input)="onSearchChange($any($event.target).value)"
              placeholder="Buscar por número o beneficiario..."
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <!-- Column filters -->
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Número de Contrato</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.numeroContrato"
              (input)="onColumnFilterChange('numeroContrato', $any($event.target).value)"
              placeholder="Filtrar por número..."
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Beneficiario</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.beneficiario"
              (input)="onColumnFilterChange('beneficiario', $any($event.target).value)"
              placeholder="Filtrar por beneficiario..."
            />
          </mat-form-field>
        </div>
        <button
          mat-stroked-button
          color="primary"
          (click)="clearFilters()"
          style="height: 40px; align-self: center"
        >
          <mat-icon style="margin-right: 6px">filter_alt_off</mat-icon>
          Limpiar filtros
        </button>
      </div>
    }

    <div id="contratos-table-section" class="table-container">
      @if (loading$ | async) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>{{ labels.loadingContratos }}</p>
        </div>
      } @else if (error$ | async) {
        <div class="error-container">
          <p class="error-message">{{ error$ | async }}</p>
        </div>
      } @else {
        <div class="table-wrapper">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
            <!-- ID Column -->
            <ng-container matColumnDef="numeroContratoId">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableId }}</th>
              <td mat-cell *matCellDef="let contrato">
                {{ contrato.numeroContratoId }}
              </td>
            </ng-container>

            <!-- Numero Contrato Column -->
            <ng-container matColumnDef="numeroContrato">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableNumeroContrato }}</th>
              <td mat-cell *matCellDef="let contrato">
                {{ contrato.numeroContrato }}
              </td>
            </ng-container>

            <!-- Anio Contrato Column -->
            <ng-container matColumnDef="anioContrato">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableAnioContrato }}</th>
              <td mat-cell *matCellDef="let contrato">
                {{ contrato.anioContrato }}
              </td>
            </ng-container>

            <!-- Tipo Contrato Column -->
            <ng-container matColumnDef="tipoContrato">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableTipoContrato }}</th>
              <td mat-cell *matCellDef="let contrato">
                {{ contrato.tipoContratoNombre || 'N/A' }}
              </td>
            </ng-container>

            <!-- Perfil Column -->
            <ng-container matColumnDef="perfil">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tablePerfil }}</th>
              <td mat-cell *matCellDef="let contrato">
                {{ contrato.perfilNombre || 'N/A' }}
              </td>
            </ng-container>

            <!-- Valor Honorarios Column -->
            <ng-container matColumnDef="valorHonorariosMes">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableValorHonorarios }}</th>
              <td mat-cell *matCellDef="let contrato">
                ${{ contrato.valorHonorariosMes | number: '1.0-0' }}
              </td>
            </ng-container>

            <!-- Beneficiario Column -->
            <ng-container matColumnDef="beneficiario">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableBeneficiario }}</th>
              <td mat-cell *matCellDef="let contrato">
                {{ contrato.beneficiario }}
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableActions }}</th>
              <td mat-cell *matCellDef="let contrato">
                <div class="action-buttons">
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="openCreateModal(contrato)"
                    matTooltip="{{ labels.tooltipEdit }}"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [class.selected-row]="selectedContrato?.numeroContratoId === row.numeroContratoId"
            ></tr>
          </table>

          @if (dataSource.data.length === 0) {
            <div class="no-data-container">
              <mat-icon class="no-data-icon">inbox</mat-icon>
              <p class="no-data-message">No hay contratos disponibles</p>
              <p class="no-data-submessage">
                Haga clic en "Crear Contrato" para agregar el primero
              </p>
            </div>
          }

          <mat-paginator
            #paginator
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange()"
            aria-label="Seleccionar página de contratos"
          ></mat-paginator>
        </div>
      }
    </div>
  </mat-card>
</div>

<!-- Create/Edit Modal -->
<ng-template #createContratoModal>
  <h2 id="contrato-modal-title" mat-dialog-title>
    {{ isEditing ? labels.editContrato : labels.createContrato }}
  </h2>

  <mat-dialog-content id="contrato-modal-content" class="modal-content">
    <form id="contrato-form" [formGroup]="contratoForm" class="form-layout">
      <!-- Left Column -->
      <div class="form-column-left">
        <!-- ID Field (only show in edit mode) -->
        @if (isEditing && selectedContrato) {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ labels.numeroContratoId }}</mat-label>
            <input matInput [value]="selectedContrato.numeroContratoId" readonly disabled />
          </mat-form-field>
        }

        <!-- Anio Contrato Field -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.anioContrato }}*</mat-label>
          <input
            matInput
            type="number"
            formControlName="anioContrato"
            placeholder="Ingrese el año del contrato"
            [class.error-field]="hasError('anioContrato')"
          />
          @if (hasError('anioContrato')) {
            <mat-error>{{ getErrorMessage('anioContrato') }}</mat-error>
          }
        </mat-form-field>

        <!-- Beneficiario Field -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.beneficiario }}*</mat-label>
          <input
            matInput
            formControlName="beneficiario"
            placeholder="Ingrese el beneficiario del contrato"
            maxlength="200"
            [class.error-field]="hasError('beneficiario')"
          />
          @if (hasError('beneficiario')) {
            <mat-error>{{ getErrorMessage('beneficiario') }}</mat-error>
          }
        </mat-form-field>

        <!-- Perfil Field -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.perfilId }}*</mat-label>
          <mat-select formControlName="perfilId" [class.error-field]="hasError('perfilId')">
            @for (perfil of perfiles$ | async; track perfil.perfilId) {
              <mat-option [value]="perfil.perfilId">{{ perfil.nombrePerfil }}</mat-option>
            }
          </mat-select>
          @if (hasError('perfilId')) {
            <mat-error>{{ getErrorMessage('perfilId') }}</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Right Column -->
      <div class="form-column-right">
        <!-- Numero Contrato Field -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.numeroContrato }}*</mat-label>
          <input
            matInput
            formControlName="numeroContrato"
            placeholder="Ingrese el número del contrato"
            maxlength="50"
            [class.error-field]="hasError('numeroContrato')"
          />
          @if (hasError('numeroContrato')) {
            <mat-error>{{ getErrorMessage('numeroContrato') }}</mat-error>
          }
        </mat-form-field>

        <!-- Tipo Contrato Field -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.tipoContratoId }}*</mat-label>
          <mat-select
            formControlName="tipoContratoId"
            [class.error-field]="hasError('tipoContratoId')"
          >
            @for (tipo of tiposContrato$ | async; track tipo.tipoContratoId) {
              <mat-option [value]="tipo.tipoContratoId">{{ tipo.nombre }}</mat-option>
            }
          </mat-select>
          @if (hasError('tipoContratoId')) {
            <mat-error>{{ getErrorMessage('tipoContratoId') }}</mat-error>
          }
        </mat-form-field>

        <!-- Valor Honorarios Field -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.valorHonorariosMes }}*</mat-label>
          <input
            matInput
            type="number"
            formControlName="valorHonorariosMes"
            placeholder="Ingrese el valor de honorarios por mes"
            [class.error-field]="hasError('valorHonorariosMes')"
          />
          @if (selectedPerfilRange) {
            <mat-hint style="color: #1976d2">
              Rango salarial: ${{ formatNumber(selectedPerfilRange.minimo) }} - ${{
                formatNumber(selectedPerfilRange.maximo)
              }}
            </mat-hint>
          }
          @if (hasError('valorHonorariosMes')) {
            <mat-error>{{ getErrorMessage('valorHonorariosMes') }}</mat-error>
          }
        </mat-form-field>
      </div>
    </form>

    <!-- Form-level errors -->
    @if (getFormError()) {
      <div
        class="form-error-message"
        style="
          color: #f44336;
          padding: 12px;
          background-color: #ffebee;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <mat-icon style="vertical-align: middle; margin-right: 8px">error</mat-icon>
        {{ getFormError() }}
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions id="contrato-modal-actions" align="end">
    <button
      id="save-contrato-button"
      mat-button
      mat-raised-button
      color="primary"
      (click)="saveContrato()"
      [disabled]="contratoForm.invalid"
    >
      <mat-icon>save</mat-icon>
      {{ labels.save }}
    </button>
    <button id="cancel-contrato-button" mat-button (click)="closeModal()">
      {{ labels.cancel }}
    </button>
  </mat-dialog-actions>
</ng-template>
